import React, { useContext, useEffect, useState } from 'react';
import {
  ForgeAppBar,
  ForgeAppBarMenuButton,
  ForgeIcon,
} from '@tylertech/forge-react';
import { Context } from '../../store/Store.js';
import { useNavigate } from 'react-router';
import ReportsButton from './ReportsButton/ReportsButton.js';
import NavDrawer from './NavDrawer/NavDrawer.js';
//import Help from './Help/Help.js';
import MyProfile from './MyProfile/MyProfile.js';
import { DARK, LIGHT } from '../../static/keyWords.js';
import { ZoomContext } from '../../contexts/zoomContext.js';
import { REDUCER_ACTION_TYPES } from '../../store/Reducer.js';
import { NAVIGATION_PATHS } from '../../static/navigationPaths.js';
import './OmniBarNavigation.scss';
import { useUser } from '../../contexts/userContext.js';

const OmniBarNavigation = () => {
  const [isOpen, setIsOpen] = useState(true);
  const [, dispatch] = useContext(Context);
  const { autoHeight } = useContext(ZoomContext);
  const { user, setUser } = useUser();

  const navigate = useNavigate();

  useEffect(() => {
    if (autoHeight) {
      setIsOpen(false);
    }
  }, [autoHeight]);

  useEffect(() => {
    const theme = document.documentElement.getAttribute('data-forge-theme');
    if (theme) {
      document.body.setAttribute('data-ag-theme-mode', theme);
    }
  }, []);

  const toggleOpen = () => {
    setIsOpen((prevState) => !prevState);
    dispatch({ type: REDUCER_ACTION_TYPES.TOGGLE_NAV_DRAWER, payload: !isOpen });
  };

  const handleLogout = () => {
    localStorage.clear();
    setUser(null);

    const systemTheme = window.matchMedia('(prefers-color-scheme: dark)').matches ? DARK : LIGHT;
    document.documentElement.setAttribute('data-forge-theme', systemTheme);
    document.body.setAttribute('data-ag-theme-mode', systemTheme);

    dispatch({ type: REDUCER_ACTION_TYPES.TOGGLE_THEME, payload: systemTheme });
    dispatch({ type: REDUCER_ACTION_TYPES.SET_USER_NAVIGATED, payload: false });
    dispatch({ type: REDUCER_ACTION_TYPES.FIRE_UNSAVED_CHANGES_DIALOG, payload: false });

    navigate(NAVIGATION_PATHS.LOGOUT, {
      state: { sessionExpired: false, destroySession: true, gatewayLogin: user?.gatewayLogin },
    });
  };

  return (
    <>
      <ForgeAppBar
        title-text="Priority Based Budgeting"
        theme-mode="scoped"
        slot="header"
      >
        <ForgeAppBarMenuButton slot="start" onclick={toggleOpen} />
        <ForgeIcon
          external
          slot="logo"
          name="tyler_talking_t_logo"
        />
        {user?.activeOrganization && (
          <>
            <ReportsButton />
            {/* <Help /> */}
            <MyProfile handleLogout={handleLogout} />
          </>
        )}
      </ForgeAppBar>
      <NavDrawer isOpen={isOpen} />
    </>
  );
};

export default OmniBarNavigation;
